import { StyleSheet } from 'react-native';

/**
 * Tab icon size comes from the tab navigator; image dimensions follow `size`.
 */
export const getWorldCupTabIconStyles = (size: number) =>
  StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    iconWrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2,
    },
    iconWrapperFocused: {
      transform: [{ scale: 1.06 }],
    },
    image: {
      width: size,
      height: size,
      alignItems: 'center',
      justifyContent: 'center',
    },
    imageFocused: {
      opacity: 1,
    },
    imageMuted: {
      opacity: 0.55,
    },
    imageLocked: {
      opacity: 0.38,
    },
    lockBadge: {
      position: 'absolute',
      right: -2,
      bottom: -2,
      alignItems: 'center',
      justifyContent: 'center',
    },
  });
